import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Article from "../../models/Article";

function ArticleCitation({ article }) {
  if (!article) return null;

  const description = useMemo(() => {
    return [
      article.mainAuthor ? article.mainAuthor : "",
      article.year ? article.year : "",
      article.citations ? article.citations : "",
    ]
      .filter(Boolean)
      .join(" · ");
  }, []);

  return (
    <div className="tw-relative tw-bg-blueGray-100 tw-rounded-lg tw-p-1">
      <div className="text-larger-1 tw-font-semibold tw-text-blueGray-600">
        {article.title.text}
        <div className="tw-w-2 tw-inline-block" />
        <a
          target="_blank"
          href={article.varsomeLink}
          className="tw-inline-block tw-text-2xs"
        >
          VarSome: {article.pubmedId}
          <i className="fa fa-external-link tw-px-1" />
        </a>
        <div className="tw-inline-block tw-w-4" />
        <a
          target="_blank"
          href={article.pubmedLink}
          className="tw-inline-block tw-text-2xs"
        >
          PubMed: {article.pubmedId}
          <i className="fa fa-external-link tw-px-1" />
        </a>
      </div>
      <div className="tw-h-0.5" />
      <div>{description}</div>
      <div className="tw-h-0.5" />
      <div>{article.journal}</div>
      <div className="tw-h-0.5" />
    </div>
  );
}

ArticleCitation.propTypes = {
  article: PropTypes.instanceOf(Article),
};

ArticleCitation.defaultProps = {
  article: null,
};

export default ArticleCitation;
